import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import "./before-start-application.scss";
import { Link } from "react-router-dom";

const BeforeStartApplication = (props) => {
  const [isRead, setIsRead] = useState(false);
  const [isRisk, setIsRisk] = useState(false);
  const handleCheck = async (item, e) => {
    if (item === "read") {
      setIsRead(e.target.checked);
    }
    if (item === "risk") {
      setIsRisk(e.target.checked);
    }
  };
  useEffect(() => {
    props.getIsAgreed(!(isRead && isRisk));
  }, [isRead, isRisk]);
  return (
    <Card className="bsa-container">
      <Card.Body>
        <p className="heading">Before you start</p>
        <p className="description">
          There are a few things that we need you to be aware of before you
          apply to take your pension. It’s really important that you understand
          these considerations before you make your choice.
        </p>
        <p className="description">
          Please do not make any financial commitments until you have received
          your pension.
        </p>
        <br />

        <p className="sub-heading">Decide what you want from your retirement</p>
        <p className="description">
          First off, if you’ve not done so already, we’d recommend that you use
          our{" "}
          <Link to="/plan?tab=retirementExplorer" className="font-bold">
            retirement explorer
          </Link>{" "}
          to help you understand the options that are available to you. It’ll
          help you get your head round your options so you can start considering
          what’s right for you.
        </p>
        <br />

        <p className="sub-heading">Combining your TPT pension pots</p>
        <p className="description">
          About 10% of our customers have 2 or more TPT memberships. Please
          consider combining your TPT pots before you apply to take your
          pension.
        </p>
        <p className="description">
          You may prefer the simplicity of managing a single drawdown pot in
          retirement rather than a separate drawdown for each membership.
        </p>
        <p className="description">
          You’ll be using TPT drawdown if you take your tax-free cash only
          (leaving the rest invested), or would like a retirement income from
          your pot.
        </p>
        <p className="description">
          No action is required if you want to take your pension as a single
          lump sum, buy an annuity or take your money in chunks.
        </p>
        <br />

        <p className="sub-heading">Need some help?</p>
        <p className="description">
          Choosing how you take your pension is an important decision. Some of
          the choices you make can’t be reversed and the decisions you make now
          may affect the money you receive in retirement.
        </p>
        <p className="description">
          We’d strongly recommend that you seek additional guidance or financial
          advice before making your final choice. We’d also encourage you to
          take up a free appointment with Pension Wise, a government funded
          service from MoneyHelper that offers impartial guidance on your
          pension options.
        </p>
        <p className="description">
          You’ll find more information on Pension Wise and other places to find
          guidance and advice at{" "}
          <a
            href="https://tpt.co.uk/guidance-and-advice"
            target="_blank"
            rel="noreferrer"
            className="font-bold"
          >
            tpt.co.uk/guidance-and-advice.
          </a>
        </p>
        <br />

        <p className="sub-heading">Stopping your contributions</p>
        <p className="description">
          If you’re still paying in but planning to stop contributions, please
          inform your employer as soon as possible{" "}
          <span className="font-bold">before</span> you apply for your pension.
          Your employer will inform us via payroll that you intend to leave the
          scheme.
        </p>
        <p className="description">
          The final contribution from your employer may be up to three weeks
          after the month you leave. Please allow extra time for your
          application to be processed.
        </p>
        <br />

        <p className="sub-heading">Shop around</p>
        <p className="description">
          We’d always encourage you to shop around and see what other pension
          providers are able to offer you. Other providers can offer different
          options for your pension pot with different features, rates of
          payment, charges and tax implications. You may also transfer out some
          or all of your TPT pot to another provider.
        </p>
        <br />

        <p className="sub-heading">Review the risks</p>
        <p className="description">
          Before you make your pension choices, please review the risks
          associated with each pension option at{" "}
          <a
            href="https://tpt.co.uk/risk-warnings"
            target="_blank"
            rel="noreferrer"
            className="font-bold"
          >
            tpt.co.uk/risk-warnings
          </a>
          .
        </p>
        <br />

        <p className="sub-heading">Look out for pension scams</p>
        <p className="description">
          People preparing to take their pensions are often targets for scams.
          Make sure you know what to look out for and how to spot an offer or
          request that isn’t genuine at{" "}
          <a
            href="https://www.fca.org.uk/scamsmart"
            target="_blank"
            rel="noreferrer"
            className="font-bold"
          >
            https://www.fca.org.uk/scamsmart
          </a>
          .
        </p>
        <br />

        <p className="sub-heading">About tax</p>
        <p className="description">
          You’ll usually receive 25% of your pension savings free of tax, with
          the remaining 75% being taxable. You’ll pay tax on any income you
          receive above your personal allowance each year. The State Pension is
          also taxable and counts toward your personal allowance.
        </p>
        <p className="description">
          If tax on your pension is higher than you believe is correct for your
          earnings, you can request a refund at{" "}
          <a
            href="https://gov.uk/claim-tax-refund"
            target="_blank"
            rel="noreferrer"
            className="font-bold"
          >
            gov.uk/claim-tax-refund
          </a>
          , or it may be refunded in the next tax year.
        </p>
        <br />

        <p className="sub-heading">Income related state benefits and debt</p>
        <p className="description">
          The way you take your pension savings may affect your entitlement to
          income related benefits and may also have implications if you’re in
          debt. Find out more at{" "}
          <a
            href="https://moneyhelper.org.uk"
            target="_blank"
            rel="noreferrer"
            className="font-bold"
          >
            moneyhelper.org.uk
          </a>{" "}
          or{" "}
          <a
            href="https://citizensadvice.org.uk"
            target="_blank"
            rel="noreferrer"
            className="font-bold"
          >
            citizensadvice.org.uk
          </a>
          {", "}
          or speak to a financial adviser.
        </p>
        <div className="bsa-agreement-checkbox">
          <CustomCheckbox
            name="read-understood"
            type="checkbox"
            label="I confirm that I have read and understood the information above"
            variantName="custom-checkbox mt-4"
            onChange={(e) => handleCheck("read", e)}
          />
          <CustomCheckbox
            name="risk-warnings"
            type="checkbox"
            label={
              <span>
                I confirm that I have read the risk warnings at{" "}
                <a
                  href="https://tpt.co.uk/risk-warnings"
                  target="_blank"
                  rel="noreferrer"
                  className="font-bold"
                >
                  tpt.co.uk/risk-warnings
                </a>
              </span>
            }
            variantName="custom-checkbox mt-3"
            onChange={(e) => handleCheck("risk", e)}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default BeforeStartApplication;
